import { InsoleSide } from "@prisma/client";
import { TKey } from "@/app/translations/TKey";
import { T } from "@/app/translations/Translations";
import { PublicInsoleModel } from "@/app/types/PublicInsoleModel";
import { Files } from "@/app/vars/Files";

export function modelPreviewUrl(model: Pick<PublicInsoleModel, "previewUrl" | "side">): string {
  if (model.previewUrl) {
    return model.previewUrl;
  }

  return model.side === InsoleSide.RIGHT
    ? Files.IMAGES.INSOLE_PREVIEW_RIGHT
    : Files.IMAGES.INSOLE_PREVIEW_LEFT;
}

export function visibilityLabel(isPublic: boolean, lang: string): string {
  return T(isPublic ? TKey.INSOLE_MODEL_PUBLIC : TKey.INSOLE_MODEL_PERSONAL, lang) as string;
}
